import { ReplaySubject } from 'rxjs';

import { logStore } from './lib/log-store';

export const globalActions = new ReplaySubject();

if (logStore() && window.__REDUX_DEVTOOLS_EXTENSION__?.connect) {
  let isUpdatedFromDevtools = false;

  const connection = window.__REDUX_DEVTOOLS_EXTENSION__.connect({
    name: 'Global Actions',
    instanceId: 1,
  });

  connection.init({});

  // Handle devTools slider history
  connection.subscribe((evt) => {
    if (evt.type === 'DISPATCH') {
      const prevAction = JSON.parse(evt.state);
      isUpdatedFromDevtools = true;
      globalActions.next(prevAction);
      isUpdatedFromDevtools = false;
    }
  });

  // Update devTools
  globalActions.subscribe((action) => {
    if (!isUpdatedFromDevtools) {
      connection.send(action.type, action);
    }
  });
}
